/* Kizuna Living — dark mode toggle
   Adds a floating button that flips the .kz-dark class on <html> and remembers
   the choice in localStorage. The pre-paint script in theme.liquid applies the
   saved choice before first paint to avoid a flash. */
(function () {
  var KEY = 'kzTheme';

  function isDark() {
    return document.documentElement.classList.contains('kz-dark');
  }

  function saved() {
    var q = location.search;
    if (/[?&]kztheme=dark/.test(q)) return true;
    if (/[?&]kztheme=light/.test(q)) return false;
    try {
      return localStorage.getItem(KEY) === 'dark';
    } catch (e) {
      return false;
    }
  }

  function apply(dark) {
    document.documentElement.classList.toggle('kz-dark', dark);
  }

  function build() {
    if (document.querySelector('.kz-theme-toggle') || !document.body) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kz-theme-toggle';
    btn.setAttribute('aria-label', 'Toggle dark mode');

    function sync() {
      var dark = isDark();
      btn.textContent = dark ? '☀' : '☾'; /* sun when dark, moon when light */
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      btn.title = dark ? 'Switch to light mode' : 'Switch to dark mode';
    }

    btn.addEventListener('click', function () {
      var dark = !isDark();
      apply(dark);
      try {
        localStorage.setItem(KEY, dark ? 'dark' : 'light');
      } catch (e) {}
      sync();
    });

    sync();
    document.body.appendChild(btn);
  }

  apply(saved());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  /* Re-inject if the theme editor reloads a section */
  document.addEventListener('shopify:section:load', build);
})();
